import type { RateTableErrorInterface } from './types/RateTableErrorInterface';

export class RateTableExternalError
  extends Error
  implements RateTableErrorInterface
{
  readonly title = 'Unable to load offers';
  readonly copy = 'Check your network connection and try again.';

  constructor(message: string) {
    const identifier = '[RATE_TABLE_EXTERNAL_ERROR]';

    super(`${identifier} ${message}`);

    this.name = identifier;
  }
}
